import React, { useState, useEffect } from "react";

import logo from "assets/images/sbs/tot-new/tot-logo.png";
import roundOver from "assets/images/sbs/tot-new/round-over.png";

const Over = ({ users, mobile_app, player_score }) => {
  const [score_array, setScore_array] = useState();

  useEffect(() => {
    const array = player_score.map((obj) => {
      const user = users.find((user) => obj.player_id === user.player_id);
      return {
        ...obj,
        profile_image: user.profile_image,
        display_name: user.display_name
      };
    });
    setScore_array(array);
  }, []);

  return (
    <div className="round-over">
      <div className="text-center">
        <img src={logo} alt="logo" className="my-3" />
        <img src={roundOver} className="over-img" alt="logo" />
      </div>
      <div className="final-players">
        <div
          className={`final-players-list ${
            mobile_app ? "mobile-cnt" : "web-cnt"
          }`}
        >
          {score_array?.map((player, index) => (
            <div key={index} className="final-players-flex">
              <div className="players-info">
                <img src={player.profile_image} className="mr-2" alt="" />
                <p className="name">{player.display_name}</p>
              </div>
              <h6 className="score">{player?.score}</h6>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Over;
